import React from 'react';
import ReactDOM from 'react-dom';

import * as analytics from 'analytics/Analytics';
import AntibodyMap from 'antibodies/antibody-map/AntibodyMap';
import AntibodyMapTabState from 'antibodies/antibody-map/AntibodyMapTabState';
import BufferTabView from 'buffers/BufferTabView';
import {ANTIBODIES_ANALYTICS_ACTIONS} from 'constants/analytics-products/AntibodiesAnalyticsConstants';
import {renderToDOM} from 'redux-stores/ReduxDOMRender';

export interface AntibodyMapTabProps {
  antibodyId: string;
}

function AntibodyMapTab(props: AntibodyMapTabProps): JSX.Element {
  return (
    <div className="react-tab-container">
      <AntibodyMap {...props} />
    </div>
  );
}

export default class AntibodyMapTabView extends BufferTabView<AntibodyMapTabState> {
  override render(): this {
    renderToDOM(<AntibodyMapTab antibodyId={this.model.get('antibodyId')} />, this.el);
    analytics.trackEvent(ANTIBODIES_ANALYTICS_ACTIONS.OPENED_ANTIBODY_ENTITY, {
      antibodyId: this.model.get('antibodyId'),
    });
    return this;
  }

  override remove(): Backbone.View<AntibodyMapTabState> {
    ReactDOM.unmountComponentAtNode(this.el);
    return super.remove();
  }
}

AntibodyMapTabView.prototype.className = 'buffer-tab buffer-tab--no-padding';
